import React, { useState, useRef } from "react";
import { toast } from "react-toastify";
import { useRouter } from "../../../lib/hooks/useRouter";
import { useScrollToTop } from "../../../lib/hooks/useScrollToTop";
import { useGroupsRequests } from "../../../api/grpc/permissions/useGroupsRequests";
import { useGroupFormik } from "../../../components/Groups/EditGroup/lib/useGroupFormik";
import { useGroupContext } from "../../../lib/context/Groups/GroupContext";

import { Button } from "../../../components/shared/Button/Button";
import { PageHeader } from "../../../components/shared/PageHeader/PageHeader";
import { GroupForm } from "../../../components/Groups/EditGroup/GroupForm";
import { tooltips } from "../../../lib/utils/tooltips";
import { USERS_GROUPS_ROOT_PATH } from "../../../lib/routes/routes";

export const AddGroup = () => {
  useScrollToTop();
  const [loading, setLoading] = useState(false);
  const { history } = useRouter();

  const { refetchGroups } = useGroupContext();
  const { createPermissionGroup } = useGroupsRequests();

  const formik = useGroupFormik({
    onSubmit: async (values) => {
      try {
        setLoading(true);

        const {
          response: { id },
        } = await createPermissionGroup({
          name: values.name,
          description: values.description,
          accessEverything: values.accessEverything,
          rooms: values.rooms.map((room) => room.id),
          desks: values.desks.map((desk) => desk.id),
          locations: values.locations || [],
          members: values.members || [],
          deskBookingEnabled: values.deskBookingEnabled,
          roomBookingEnabled: values.roomBookingEnabled,
        });

        toast.success("Group created successfully.");

        await refetchGroups();

        history.push(`${USERS_GROUPS_ROOT_PATH}/edit/${id}`);
      } catch (error: any) {
        toast.error(
          error?.message || "Failed to create group. Please try again."
        );
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <div className="TemplateManage">
      <PageHeader
        title="Create group"
        hideBorder
        message={
          tooltips.groups?.addGroup ||
          "Create a new group to organize user access and permissions."
        }
      />

      <div className="flex-a-center justify-content-end gap-1 mb-2">
        <Button
          title="Cancel"
          color="outline-secondary"
          size="small"
          onClick={() => history.push(USERS_GROUPS_ROOT_PATH)}
        />
        <Button
          color="primary"
          size="small"
          title="Create"
          onClick={() => formik.handleSubmit()}
          disabled={loading}
        />
      </div>

      <GroupForm formik={formik} />
    </div>
  );
};
